import React, { Fragment } from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/fabric-extension-lib-types';
import {
	MacroExperienceSuccess,
	getMacroAttributesFromADFNode,
	getExperienceName,
} from '@confluence/macro-tracker';
import { CreateFromTemplateLoader } from '@confluence/create-from-template/entry-points/CreateFromTemplate';
import { useSessionData } from '@confluence/session-data';

export const CreateFromTemplate = ({ ...macroDefaultProps }: ExtensionHandlerProps) => {
	const { contentId, extensionKey, node, mode } = macroDefaultProps;
	const attributes = getMacroAttributesFromADFNode(node);

	const { cloudId, userId } = useSessionData();

	return (
		<Fragment>
			<CreateFromTemplateLoader
				userId={userId || ''}
				cloudId={cloudId}
				macroDefaultProps={macroDefaultProps}
			/>
			<MacroExperienceSuccess
				name={getExperienceName(mode, node)}
				contentId={contentId}
				extensionKey={extensionKey}
				mode={mode}
				attributes={attributes}
			/>
		</Fragment>
	);
};
